<template>
    <div class="Right-Content">
        <div class="content">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Right-Content",
    }

</script>

<style lang="less" scoped>
    .Right-Content {
        .content {
            width: 100%;
            padding: 0;
            margin: 0;
        }
    }


</style>
